export const authStep = {
  SIGN_IN: "SIGN_IN",
  DONE: "DONE",
  NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED:
    "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
  CONFIRM_SIGN_IN_WITH_TOTP_CODE: "CONFIRM_SIGN_IN_WITH_TOTP_CODE",
  CONFIRM_SIGN_IN_WITH_SMS_CODE: "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  CONFIRM_SIGN_IN_WITH_EMAIL_CODE: "CONFIRM_SIGN_IN_WITH_EMAIL_CODE",
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP: "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
  FORGET_PASSWORD: "FORGET_PASSWORD",
  CONFIRM_RESET_PASSWORD_WITH_CODE: "CONFIRM_RESET_PASSWORD_WITH_CODE",
};

export interface GetSSOSigninRequest {
  redirectUri: string;
  clientId: string;
  responseType: string;
  scope?: string;
  state?: string;
  deviceId?: string;
}

export interface SSOToken {
  accessToken: string;
  refreshToken: string;
  idToken: string;
  expiresIn: number;
  tokenType: string;
}

export interface GetSSOSigninResponse {
  code?: string;
  token?: SSOToken;
}

export interface GetAuthTokenRequest {
  code: string;
  clientId: string;
  redirectUri: string;
  deviceId?: string;
}

export interface GetAuthTokenResponse {
  accessToken: string;
  refreshToken: string;
  idToken: string;
}
